(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-text"]) return;
  try {
    
  (() => {
    const initCollectionSeoText = (container = document) => {
      container.querySelectorAll('[data-collection-seo-text]').forEach((content) => {
        if (content.dataset.collectionSeoTextInitialized === 'true') return;

        content.dataset.collectionSeoTextInitialized = 'true';

        const preview = content.querySelector('[data-collection-seo-text-preview]');
        const full = content.querySelector('[data-collection-seo-text-full]');
        const toggle = content.querySelector('[data-collection-seo-text-toggle]');
        const lead = content.querySelector('[data-collection-seo-text-lead]');
        const limit = Number(content.dataset.previewLimit || 200);

        if (!preview || !full || !toggle) return;

        const normalizeWhitespace = (rawText) =>
          rawText.replace(/\s+/g, ' ').trim();

        const textWithoutFirstH1 = () => {
          const probe = /** @type {HTMLElement} */ (full.cloneNode(true));
          const cloned = probe.querySelector('h1:first-of-type');
          if (cloned != null) cloned.remove();
          return normalizeWhitespace(probe.textContent);
        };

        /** @returns {{ normalized: string, visibleCharacters: number, cutoff: number }} */
        const measureCutoff = (rawText) => {
          const normalized = normalizeWhitespace(rawText);
          let visibleCharacters = 0;
          let cutoff = normalized.length;

          for (let index = 0; index < normalized.length; index += 1) {
            if (!/\s/.test(normalized[index])) visibleCharacters += 1;
            if (visibleCharacters === limit) {
              cutoff = index + 1;
              break;
            }
          }

          return { normalized, visibleCharacters, cutoff };
        };

        /** Full content (before extracting h1) decides if truncation is needed. */
        let { normalized, visibleCharacters, cutoff } = measureCutoff(full.textContent);

        if (visibleCharacters < limit || cutoff >= normalized.length) {
          content.classList.remove('has-toggle');
          toggle.hidden = true;
          return;
        }

        const firstHeading = full.querySelector('h1:first-of-type');
        const hasBodyBeyondHeading = textWithoutFirstH1().length > 0;
        const shouldElevateHeading = firstHeading != null && lead != null && hasBodyBeyondHeading;

        if (shouldElevateHeading) {
          lead.appendChild(firstHeading);
          lead.hidden = false;
        }

        const afterExtract = measureCutoff(full.textContent);
        cutoff = afterExtract.cutoff;
        normalized = afterExtract.normalized;

        if (
          afterExtract.visibleCharacters < limit ||
          cutoff >= normalized.length ||
          normalized.length === 0
        ) {
          preview.textContent = normalized;
        } else {
          preview.textContent = `${normalized.slice(0, cutoff).trim()}...`;
        }

        content.classList.add('has-toggle', 'is-collapsible');
        toggle.hidden = false;

        toggle.addEventListener('click', () => {
          const isExpanded = content.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', String(isExpanded));
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCollectionSeoText());
    } else {
      initCollectionSeoText();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCollectionSeoText(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
